import { Button, Dialog, DialogActions, DialogContent, DialogTitle, List, ListItem, ListItemText } from "@material-ui/core";
import React, {Component} from "react";

/**
 * shopping_list
 * 
 * onCreateClick(shopping_list)
 * onSelectClick(shopping_list)
 * onCancelClick()
 */

class SelectPurchaseTypeDialog extends Component {
    
    render() {
        return <Dialog open fullWidth>
            <DialogTitle>Ваш заказ</DialogTitle>
            <DialogContent>
                <List>
                    {this.props.shopping_list.map((item, n) => <ListItem key={n} button>
                        <ListItemText primary={item.name} />
                    </ListItem>)}
                </List>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={e=>{
                        e.stopPropagation()
                        if (typeof this.props.onCancelClick === "function") {
                            this.props.onCreateClick(this.props.shopping_list)
                        }
                    }}
                >Создать закупку</Button>
                <Button
                    onClick={e=>{
                        e.stopPropagation()
                        if (typeof this.props.onCancelClick === "function") {
                            this.props.onSelectClick(this.props.shopping_list)
                        }
                    }}
                >Добавить в существующую закупку</Button>
                <Button
                    onClick={e=>{
                        e.stopPropagation()
                        if (typeof this.props.onCancelClick === "function") {
                            this.props.onCancelClick()
                        }
                    }}
                >Отмена</Button>
            </DialogActions>
        </Dialog>
    }

}

export default SelectPurchaseTypeDialog